import React from "react";
import { withRouter } from "react-router";
import "../../modules/notes/AllNotes.css";
import "firebase/auth"; // Import Firebase auth module
import "firebase/database";
import * as actions from "../../redux/actions/auth.action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getProviderData } from "../../actions";

import { invitePatient } from "./actions";
import { store } from "../../redux/store";
import { setEpicDetails } from "../../redux/actions/epic.action";
import CircleLoader from "../notes/component/CircleLoader";
import { signInWithCustomTokenCustom } from "../../actions/firebase";
class FhirClientProvider extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         jsonRes: null,
         patientId: "",
         error: false,
      };
   }

   async componentDidMount() {
      const searchParams = new URLSearchParams(this.props.location.search);
      const iss = searchParams.get("iss");
      const launchToken = searchParams.get("launch");

      var obj = {
         action: "onboarding",
         subAction: "epicEHRLaunch",
         iss: iss,
         token: launchToken,
      };

      window.socket.send(obj, (resultStatus) => {
         if (resultStatus.settings?.status === 1) {
            const customTokenApi = resultStatus.data.customTokenData;
            const dataCustomEpic = resultStatus.data.tokenData;
            const tokenEndpoint = resultStatus.data.tokenEndpoint;

            signInWithCustomTokenCustom(
               customTokenApi.customToken,
               (storeDataRedux) => {
                  let userData = { user: customTokenApi.userData };
                  this.props.savenorthwelluserobj(JSON.parse(JSON.stringify(storeDataRedux)));
                  this.props.saveusercredentials(userData);
                  getProviderData(null, true, (loggedInProviderDetails) => {
                     const url = searchParams.get("iss") + "/Patient/" + dataCustomEpic.patient; // Replace this with your actual access token
                     fetch(url, {
                        method: "GET",
                        headers: {
                           Authorization: `Bearer ${dataCustomEpic.accessToken}`,
                           "Content-Type": "application/fhir+json",
                           Accept: "application/json",
                        },
                     })
                        .then((response) => {
                           if (!response.ok) {
                              throw new Error("Network response was not ok");
                           }
                           return response.json();
                        })
                        .then(async (data) => {
                           invitePatient(
                              data,
                              loggedInProviderDetails,
                              (patientId) => {
                                 store.dispatch(
                                    setEpicDetails({
                                       accessToken: dataCustomEpic.accessToken,
                                       refreshToken: dataCustomEpic.refreshToken,
                                       encounter: dataCustomEpic.encounter,
                                       idToken: dataCustomEpic.idToken,
                                       patientId: patientId,
                                       tokenEndpoint: tokenEndpoint,
                                    })
                                 );
                                 this.props.history.push("/fhir");
                              },
                              () => {
                                 this.setState({ error: true });
                              }
                           );
                        })
                        .catch((error) => {
                           this.setState({ error: true });
                        });
                  });
               },
               () => {
                  this.setState({ error: true });
               }
            );
         } else {
            this.setState({ error: true });
         }
      });
   }

   render() {
      return (
         <div className="flex-center" style={{ width: "90%", margin: "auto", paddingTop: "30px", height: "100vh" }}>
            {this.state.error ? (
               <h1 className="text-center" style={{ color: "black", marginBottom: "10px", width: "100%" }}>
                  {"Error while Authorizing the request"}
               </h1>
            ) : (
               <div className="text-center">
                  <CircleLoader />
                  <h1 style={{ color: "black", marginBottom: "10px", marginTop: "20px" }}>{"Authorizing..."}</h1>
               </div>
            )}
         </div>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      loggedInProviderDetails: state.auth?.loggedInProviderDetails,
   };
};

const mapDispatchToProps = (dispatch) => {
   return bindActionCreators(
      {
         savenorthwelluserobj: actions.savenorthwelluserobj,
         saveusercredentials: actions.saveusercredentials,
      },
      dispatch
   );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FhirClientProvider));
